import type { IconProps } from '../types/IconProps.ts';
export const Scissors: IconProps = {
    name: 'Scissors',
    children: [
        `<circle cx="6" cy="6" r="3" />`,
        `<ellipse cx="2.97" cy="3" rx="2.97" ry="3" transform="rotate(269.5 11.92 9)skewY(-.02)" />`,
        `<path d="m8.5 8.5 3 3M15 15l5 5M8.5 15.5 20 4" />`,
    ]
};